import { ceil, floor, isNumber } from 'lodash';

export default {
  methods: {
    getRatio(num, total) {
      if (total === 0 || !isNumber(total)) {
        return 0;
      }

      return ceil((num / total) * 100);
    },

    getHours(seconds) {
      return floor(seconds / 3600);
    },

    getMinutes(seconds) {
      return floor((seconds - (this.getHours(seconds) * 3600)) / 60);
    },

    getSeconds(seconds) {
      return seconds - (this.getHours(seconds) * 3600) - (this.getMinutes(seconds) * 60);
    },

    getPercent(num, total) {
      if (total === 0 || !isNumber(total)) {
        return 0;
      }

      return ((num / total) * 100);
    },
  },
};
